module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av735-c11af2a3d1dad3ce5da94af79cfd363f.jpg";